export default __webpack_public_path__ + "static/media/cleaner_box-500x500.a83ba9f4.jpg";